<template>
  <div>
    <v-container class="pt-0 pb-5">
      <v-row>
        <v-col>
          <div class="d-flex flex-column ga-2 pa-2 rounded elevation-1 bg-white">
            <div>
              <SportipsButton toPage="Administration" chevronLeft>Retour</SportipsButton>
            </div>
            <div class="text-h5 mt-2 mb-4 font-weight-bold">Validation des sas sur justificatif</div>
            <Validation_Justificatif_Vague></Validation_Justificatif_Vague>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { useMainStore } from "@/stores/mainStore";
import { mapStores } from "pinia";
import Validation_Justificatif_Vague from "@/components/Administration/Validation_Inscriptions/Validation_Justificatif_Vague.vue";

export default {
  components: {
    Validation_Justificatif_Vague,
  },
  computed: {
    ...mapStores(useMainStore),
  },
};
</script>
